// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3hbDp","label":"LabeledBox_label__po516"};